import React, { useState } from "react";
import "./../styling/Calculator.css"

const VincentyCalculator = () => {
  const [point1, setPoint1] = useState("");
  const [point2, setPoint2] = useState("");
  const [distance, setDistance] = useState(null);

  const calculateDistance = () => {
    // Parse lat/long
    const [lat1, lon1] = cleanNumberInput(point1).split(/[, ]+/).map(Number);
    const [lat2, lon2] = cleanNumberInput(point2).split(/[, ]+/).map(Number);

    if (isNaN(lat1) || isNaN(lon1) || isNaN(lat2) || isNaN(lon2)) {
      alert("Invalid coordinates!");
      return;
    }

    // Vincenty's formula (simplified)
    const R = 6378137; // WGS-84 Major Axis
    const φ1 = (lat1 * Math.PI) / 180;
    const φ2 = (lat2 * Math.PI) / 180;
    const λ1 = (lon1 * Math.PI) / 180;
    const λ2 = (lon2 * Math.PI) / 180;

    const a = Math.pow(Math.cos(φ2) * Math.sin(λ2 - λ1), 2) +
              Math.pow(Math.cos(φ1) * Math.sin(φ2) - Math.sin(φ1) * Math.cos(φ2) * Math.cos(λ2 - λ1), 2);
    const b = Math.sin(φ1) * Math.sin(φ2) + Math.cos(φ1) * Math.cos(φ2) * Math.cos(λ2 - λ1);
    const distanceVincenty = R * Math.atan2(Math.sqrt(a), b);

    setDistance(distanceVincenty.toFixed(2));
  };

  const cleanNumberInput= (input) => {
    return input.replace(/[^0-9.,]/g, '');
}

  return (
    <div className="calculator-card">
      <h2>Vincenty Distance Calculator</h2>
      <input type="text" placeholder="Enter Point 1 (lat, long)" value={point1} onChange={(e) => setPoint1(e.target.value)} />
      <input type="text" placeholder="Enter Point 2 (lat, long)" value={point2} onChange={(e) => setPoint2(e.target.value)} />
      <button onClick={calculateDistance}>Calculate Distance</button>
      {distance && <p>Distance: {distance} meters</p>}

                  {/* Information Section */}
                  <div className="info-section">
  <h3>What is the Vincenty Distance Formula?</h3>
  <p>
    Vincenty's formula calculates the distance between two latitude-longitude points on an **ellipsoid**,
    making it **more accurate** than the Haversine formula, especially for long distances.
  </p>
  <a href="https://en.wikipedia.org/wiki/Vincenty%27s_formulae" target="_blank" rel="noopener noreferrer">
    Learn more on Wikipedia
  </a>
</div>
    </div>
  );
};

export default VincentyCalculator;